import { Button, DatePicker } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useState } from 'react';
import type { DerivedTeamRoster } from '../../../hooks/types';
import DailyRoster from '../index';

/**
 * A button that opens a modal that first asks for a date, and then
 * displays a PDF viewer with the team's roster filtered for shifts on that date.
 */
const ExportRosterAsPDFModal: React.FC<{
  readonly team: DerivedTeamRoster;
}> = ({ team }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const [date, setDate] = useState<number | undefined>(undefined);

  return (
    <>
      <Button onClick={() => setModalOpen(true)} style={{ width: '100%' }}>
        Daily Org Chart
      </Button>

      <Modal
        open={modalOpen}
        title={'Export Roster (Daily Org Chart)'}
        footer={null}
        onCancel={() => {
          setDate(undefined);
          setModalOpen(false);
        }}
        width={date === undefined ? undefined : '90vw'}
        style={{ textAlign: 'center' }}
      >
        {date === undefined ? (
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <Button onClick={() => setDate(new Date().valueOf())}>Today</Button>
            <p style={{ paddingRight: 5, paddingLeft: 5, margin: 0 }}>or</p>
            <DatePicker onChange={(v) => setDate(v?.valueOf())} />
          </div>
        ) : (
          <DailyRoster team={team} date={date} height={'60vh'} />
        )}
      </Modal>
    </>
  );
};
export default ExportRosterAsPDFModal;
